import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typography } from '@telus-uds/components-web';

import { Thead, Tr, Th, Td } from './css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import getFormattedPricing from '../../utils';
import { isCustomPricingCorporate as checkCustomPricingCorporate } from '../../../../utils/corporatePricing';
import { getRateplanTotal, getDeliveryCharges } from '../util';
import RatePlanTableRow from './rateplanTableRow';

const RatePlanTable = ({
  hardware,
  orderType,
  productSelected,
  accountType,
  corporateType,
  viewType,
  ratePlans,
  setRatePlans,
  rateplanList,
  total,
  setTotal,
  setRatePlanError,
  setGeoTabNewPriceValid,
  setHardware
}) => {
  const {
    contentfulValues: {
      valueCorporate,
      valueCorporateStandardPricing,
      valueUnitPrice,
      valueTotal,
      valueRaven,
      valueNorthStarSystems
    }
  } = useLocalizedStringsContext();

  const isCustomPricingCorporate = checkCustomPricingCorporate(
    accountType,
    corporateType,
    { valueCorporate, valueCorporateStandardPricing }
  );

  const getHeader = list => (
    <Thead>
      <Tr>
        {list.map(item => {
          if (
            !(
              [valueUnitPrice, valueTotal].includes(
                _.get(item, 'fields.title', '')
              ) && isCustomPricingCorporate
            )
          )
            return <Th>{_.get(item, 'fields.title', '')}</Th>;
          return null;
        })}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const { monthly, oneTime } = getRateplanTotal(ratePlans);
    const deliveryChargesTotal = getDeliveryCharges(ratePlans);

    setTotal(previousValue => ({
      ...previousValue,
      ratePlan: monthly,
      ratePlanOneTime: oneTime,
      ...(productSelected === valueNorthStarSystems && {
        deliveryCharges: deliveryChargesTotal
      })
    }));
  }, [ratePlans]);

  useEffect(() => {
    if (productSelected === valueRaven) {
      setTotal(previousValue => ({
        ...previousValue,
        ratePlan: 0
      }));
    }
  }, [accountType]);

  return (
    <table>
      {rateplanList.map(rateplan =>
        _.get(rateplan, 'fields.isHeader', false) ? (
          <>{getHeader(_.get(rateplan, 'fields.headerList', []))}</>
        ) : (
          <RatePlanTableRow
            key={_.get(rateplan, 'sys.id', '')}
            hardware={hardware}
            orderType={orderType}
            productSelected={productSelected}
            accountType={accountType}
            corporateType={corporateType}
            rowData={rateplan}
            viewType={viewType}
            ratePlans={ratePlans}
            setRatePlans={setRatePlans}
            setRatePlanError={setRatePlanError}
            setGeoTabNewPriceValid={setGeoTabNewPriceValid}
            setHardware={setHardware}
          />
        )
      )}
      {!isCustomPricingCorporate && (
        <Tr style={{ background: '#f4f4f4' }}>
          <Td colSpan={5}>
            <Typography variant={{ bold: true }}>Total</Typography>
          </Td>
          <Td>
            <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
          </Td>
        </Tr>
      )}
    </table>
  );
};

RatePlanTable.propTypes = {
  hardware: PropTypes.shape({}).isRequired,
  orderType: PropTypes.string.isRequired,
  productSelected: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
  corporateType: PropTypes.string,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setRatePlans: PropTypes.func.isRequired,
  rateplanList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired,
  setRatePlanError: PropTypes.func.isRequired
};

export default RatePlanTable;
